import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import useResponsiveness from '@/hooks/useResponsiveness';

const createStyles = (isXS, isGapped) =>StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: isGapped ? 4 : isXS ? 0 : 1,
    alignItems: 'center',
  },
  rightPadding: {
    paddingRight: 10,
  },
  leftPadding: {
    paddingLeft: 10,
  },
});

const NavigationBarButtonContainer = ({ children, rightPadding, leftPadding, isGapped }) => {
  if (!children) {
    return null;
  }
  const { isXS } = useResponsiveness();
  const styles = useMemo(() => createStyles(isXS, isGapped), [isXS, isGapped]);

  return (
    <View 
      style={[
        styles.container,
        rightPadding && styles.rightPadding,
        leftPadding && styles.leftPadding,
        // isGapped && styles.gapped,
      ]}
      accessibilityRole="toolbar"
      accessibilityLabel="Navigation toolbar"
    >
      {children}
    </View>
  );
};

NavigationBarButtonContainer.propTypes = {
  children: PropTypes.node,
  rightPadding: PropTypes.bool,
  leftPadding: PropTypes.bool,
};

NavigationBarButtonContainer.displayName = 'NavigationBarButtonContainer';

export default React.memo(NavigationBarButtonContainer);
